import React, { useContext, useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";

const ModalRubroAdmin = ({ show, onHide, rubro, onSuccess }) => {
  const { darkMode } = useContext(DarkModeContext);
  const [form, setForm] = useState({ codigoActividad: "", nomRubro: "", descripcion: "" });
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    setForm({
      codigoActividad: rubro?.codigoActividad || "",
      nomRubro: rubro?.nomRubro || "",
      descripcion: rubro?.descripcion || "",
    });
  }, [rubro, show]);

  const cambiar = (campo, valor) => setForm((actual) => ({ ...actual, [campo]: valor }));

  const guardar = async (event) => {
    event.preventDefault();
    if (!/^\d{6}$/.test(form.codigoActividad.trim())) {
      Swal.fire("Error", "El código de actividad debe tener 6 dígitos.", "error");
      return;
    }
    if (!form.nomRubro.trim()) {
      Swal.fire("Error", "El nombre del rubro es obligatorio.", "error");
      return;
    }

    setGuardando(true);
    try {
      const response = await fetch(rubro?.id ? "/api/Rubro/editar" : "/api/Rubro/crear", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Token: getToken(),
          Id: rubro?.id || 0,
          CodigoActividad: form.codigoActividad.trim(),
          NomRubro: form.nomRubro.trim(),
          Descripcion: form.descripcion.trim() || form.nomRubro.trim(),
        }),
      });
      const text = await response.text();
      if (!response.ok) throw new Error(text || "No se pudo guardar el rubro.");
      await onSuccess?.();
      onHide?.();
      Swal.fire("Éxito", "El rubro se guardó correctamente.", "success");
    } catch (error) {
      Swal.fire("Error", error.message || "No se pudo guardar el rubro.", "error");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className={darkMode ? "modal-content text-black" : "modal-content text-black"}>
        <h5 className="lato-bold mb-4">{rubro?.id ? "Editar rubro" : "Nuevo rubro"}</h5>
        <form onSubmit={guardar}>
          <div className="row g-3">
            <div className="col-md-4">
              <label className="fs-14 mb-2">Código F.883</label>
              <input className="form-control" inputMode="numeric" maxLength={6} value={form.codigoActividad}
                onChange={(e) => cambiar("codigoActividad", e.target.value.replace(/\D/g, ""))} />
            </div>
            <div className="col-md-8">
              <label className="fs-14 mb-2">Rubro</label>
              <input className="form-control" maxLength={200} value={form.nomRubro}
                onChange={(e) => cambiar("nomRubro", e.target.value)} />
            </div>
            <div className="col-12">
              <label className="fs-14 mb-2">Descripción completa</label>
              <textarea className="form-control" rows={4} maxLength={600} value={form.descripcion}
                onChange={(e) => cambiar("descripcion", e.target.value)} />
            </div>
          </div>
          <div className="d-flex justify-content-between mt-4">
            <button type="button" className="btn btn-secondary" onClick={onHide}>Cancelar</button>
            <button type="submit" className="btn btn-success" disabled={guardando}>
              {guardando ? <Spinner animation="border" size="sm" /> : "Guardar"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalRubroAdmin;
